import React from "react";
import { getTranslation } from "../utils/localization";

interface TermsOfServiceProps {
  termsUrl: string;
  ctaButtonText?: string;
  termsAccepted: boolean;
  setTermsAccepted: (accepted: boolean) => void;
  locale?: string;
}

const TermsCheckbox: React.FC<TermsOfServiceProps> = ({
  termsUrl,
  ctaButtonText,
  termsAccepted,
  setTermsAccepted,
  locale
}) => {
  const text = getTranslation(locale);
  const buttonText = ctaButtonText ?? "Pay Now";

  return (
    <div className="my-10">
      <input
        type="checkbox"
        id="termsOfService"
        className="mr-2 cursor-pointer text-base opacity-60"
        checked={termsAccepted}
        onChange={(e) => setTermsAccepted(e.target.checked)}
        required
      />
      <label htmlFor="termsOfService">
        {text.termsText.replace('{0}', buttonText)} {' '}
        <a
          href={termsUrl}
          rel="noopener noreferrer"
          target="_blank"
          className="underline"
        >
          {text.termsOfService}
        </a>
        {"."}
      </label>
    </div>
  );
};

export default TermsCheckbox;
